<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :before-reset-search="beforeResetSearch" :before-query-search="beforeQuerySearch" res="page" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <!-- 客户名称 -->
        <el-col v-if="!$store.getters.cusId" :span="colSpan">
          <el-form-item :label="$t('StorageTransactionReport.header.CustomerName')" prop="clientCode">
            <BjSelectLov v-model="queryParams.clientCode" :clearable="false" :option-list="clientCodeList" :placeholder="$t('billingPage.CustomerName')" @change="selectChange" />
          </el-form-item>
        </el-col>
        <!--   日期    -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('InternalOrder.order')">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('StorageTransactionReport.header.RecordDate')" />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'companyName'">{{ customerList.bjGet(scope.row.cusId) }}</span>
              <span v-else-if="col.prop === 'creationDate'">{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
              <span v-else>{{ scope.row[col.prop] }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin';
import { stockApi } from '@/api';
import BjDateTimerangePicker from '@/packages/BjDateTimerangePicker';

export default {
  name: 'StorageTransactionReport',
  components: {BjDateTimerangePicker},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      queryParams: {
        clientCode: '',
        startCreationDate: '',
        endCreationDate: '',
      },
      queryApi: stockApi.getCusCcList,
      queryParamsTime: null,
      labelList: [
        { label: 'StorageTransactionReport.table.CustomerName', prop: 'companyName', isCheck: true, disabled: false },
        { label: 'StorageTransactionReport.table.Storage', prop: 'cbm', isCheck: true, disabled: false },
        { label: 'StorageTransactionReport.table.Pallet', prop: 'customerPallet', isCheck: true, disabled: false },
        { label: 'StorageTransactionReport.table.creationDate', prop: 'creationDate', isCheck: true, disabled: false },
      ],
    };
  },
  computed: {
    customerList() {
      return this.$store.getters.customerList;
    },
  },
  watch: {
    queryParamsTime(v) {
      this.queryParams.startCreationDate = (v || [])[0];
      this.queryParams.endCreationDate = (v || [])[1];
    },
  },
  methods: {
    selectChange(value) {
      const curObj = this.clientCodeList.find(item => {
        return item.clientCode === value;
      });
      const { clientCode, cusId } = curObj;
      this.queryParams = {
        ...this.queryParams,
        clientCode,
        cusId
      };
    },
    beforeQuerySearch(conditionObj) {
      return new Promise(resolve => {
        resolve(conditionObj);
      });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      this.queryParams = {
        clientCode: '',
        companyName: '',
        startCreationDate: '',
        endCreationDate: '',
      };
      return new Promise(resolve => {
        resolve();
      });
    },
  }
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
